import moment from 'moment';
import { hoursOfOperation, clientHoursOfOperation, clientWeeklyServiceTimeOptions } from '../const';

export const getHourOptions = (
  date = moment(),
  startBuffer = false,
  endBuffer = false,
  client = false
) => {
  return getHourOptionsWithBuffers(date, 
    startBuffer ? 4 : 0,
    endBuffer ? 4 : 0,
    client)
};

export const getWeeklyHourOptions = (date = moment()) => 
  clientWeeklyServiceTimeOptions.map(time => {
    const dt = date.set('hour', time).startOf('hour');
    return genHourOption(dt);
  })

export const getHourOptionsWithBuffers = (
  date = moment(),
  startBuffer = 0,
  endBuffer = 0,
  client = false,
  interval = 30
) => {
  // use client hours if flag set to true.  Otherwise use business hours
  const hours = client ? clientHoursOfOperation : hoursOfOperation;
  return getHourOptionRange(date, hours.open + startBuffer, hours.close - endBuffer, interval)
};

export const getHourOptionRange = (
  date = moment(),
  startHour,
  endHour,
  interval = 30
) => {

  // generating hour values for selects
  const start = date
    .clone()
    .set('hour', startHour)
    .startOf('hour');
  const end = date
    .clone()
    .set('hour', endHour)
    .startOf('hour');

  let hourOptions = [];
  let increment = start.clone();
  do {
    hourOptions.push(genHourOption(increment));
    increment.add(interval, 'minutes');
  } while (increment.isBetween(start, end, null, '[]'));

  return hourOptions;
};

export const genHourOption = date => {
  return {
    value: date.format('HH[:]mm'),
    label: date.format('h:mma'),
    datetime: date.clone()
  };
};

export const validateStartDate = start => {
  const minStart = moment(start).hour(hoursOfOperation.open);
  return moment(start).isBefore(minStart) ? minStart.toDate() : start;
};

export const validateEndDate = end => {
  const maxEnd = moment(end).hour(hoursOfOperation.close);
  return moment(end).isAfter(maxEnd) ? maxEnd.toDate() : end;
};

export const validateDuration = (start, end) => {
  const minEnd = moment(start).add(4, 'hour');
  return moment(end).isSameOrAfter(minEnd);
};



// WEBPACK FOOTER //
// ./src/helpers/hourOptions.js